import { css, Interpolation, Theme } from '@emotion/react'
import Chip from '@mui/material/Chip'
import { memo } from 'react'
import { palette } from '../styles/colors'
import { APP_FONT, PAPER_HEIGHTS } from '../theme'

const DIAMETER = 20.5
const SMALL_DIAMETER = 14

const commonNotificationStyles = css({
    fontFamily: APP_FONT,
    alignItems: 'center',
    backgroundColor: palette.primary,
    borderRadius: '50%',
    color: palette.commonWhite,
    display: 'flex',
    fontWeight: 700,
    justifyContent: 'center',
    margin: 0,
    padding: 0,
    '& span.MuiChip-label': {
        alignContent: 'center',
        alignItems: 'center',
        color: palette.commonWhite,
        flex: 'none',
        justifyContent: 'center',
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
        lineHeight: '1rem',
        background: 'transparent',
    },
})
const notificationStyles = css({
    height: DIAMETER,
    lineHeight: DIAMETER,
    width: DIAMETER,
})
const smallNotificationStyles = css({
    boxSizing: 'border-box',
    position: 'absolute' as const,
    zIndex: PAPER_HEIGHTS.base,
    top: -1,
    right: -1,
    height: SMALL_DIAMETER,
    lineHeight: SMALL_DIAMETER,
    width: SMALL_DIAMETER,
})

interface NotificationProps {
    small?: boolean
    styleOverrides?: Interpolation<Theme>
    value: number
}

const Notification = memo((props: NotificationProps) => {
    const { small, value, styleOverrides } = props
    const curatedValue = Number(value) > 999 ? '999' : String(value)
    const sizeStyles = small ? smallNotificationStyles : notificationStyles
    return (
        <Chip
            css={[
                commonNotificationStyles,
                sizeStyles,
                {
                    '& span.MuiChip-label': {
                        fontSize:
                            (small ? SMALL_DIAMETER : DIAMETER) *
                            (value > 99 ? 0.46 : 0.5),
                    },
                },
                styleOverrides,
            ]}
            data-testid="Notification__Chip"
            label={curatedValue}
        />
    )
})

export default Notification
